import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { withTranslation, Trans } from 'react-i18next';
import withCustomComponent from 'ui/components/withCustomComponent';
import FloorPlanById from 'pages/bookings/floorplans/[floorplan_id]/[slug]';
import { checkTerms } from 'env/checkTerms';
import { withAppWrapper } from 'ui/components/withAppWrapper';


@withAppWrapper()
@checkTerms
@withCustomComponent('FloorPlan')
@withTranslation()
@inject('appStore', 'authStore', 'floorPlanStore')
@observer
class FloorPlans extends Component {
  render() {
    return <FloorPlanById />;
  }
}

export default FloorPlans;
